export const OPEN_FAN_KEY = 'communication-conversation-messages-reply';

const store = {
	namespaced: true,
	state: {
		title: undefined,
		show: false,
		message: undefined,
		onProcessed: undefined,
	},
	actions: {
		show ({commit}, data)
		{
			commit('layout/addOpenFan', OPEN_FAN_KEY, {root: true});

			commit('setMessage', data.message);
			commit('setTitle', data.title);
			commit('setOnProcessed', data.onProcessed);

			commit('setShow', true);
		},
		close ({commit, state, dispatch}, data)
		{
			if (data?.processed && state.onProcessed)
			{
				state.onProcessed({
					message: state.message
				});
			}

			commit('setShow', false);

			commit('setTitle', undefined);
			commit('setMessage', undefined);
			commit('setOnProcessed', undefined);

			commit('layout/removeOpenFan', OPEN_FAN_KEY, {root: true});
		},
	},
	mutations: {
		setShow: (state, value) => state.show = value,
		setTitle: (state, value) => state.title = value,
		setMessage: (state, value) => state.message = value,
		setOnProcessed: (state, value) => state.onProcessed = value,
	},
};

export default store;
